const pluginName = 'charityWidget';
const defaults = {
  charityPathBase: '',
  i18n: {
    select: null,
  },
};
const selectors = {
  charitySelect: '[data-js-fundraising-organization-select]',
  charityButton: '[data-js-fundraising-organization-select-button]',
};
const classes = {
  hidden: 'd-none',
};

/**
 * Update the charity link button based on the data of the selected charity
 * @param data
 */
const updateCharityButton = (data) => {
  if (!data.elements.$charitySelect.val()) {
    data.elements.$charityButton
      .addClass(classes.hidden)
      .attr('#');
    return;
  }

  const charityPath = data.elements.$charitySelect
    .find(':selected')
    .attr('value');

  data.elements.$charityButton
    .removeClass(classes.hidden)
    .attr('href', `${data.settings.charityPathBase}${charityPath}`);
};

/**
 * Fire up
 * @param element
 * @param options
 */
const initialize = (element, options) => {
  const $element = $(element);

  if ($element.data(pluginName)) {
    return;
  }

  const settings = $.extend(true, {}, $.fn[pluginName].defaults, options);

  const elements = {
    $element,
    $charitySelect: $element.find(selectors.charitySelect),
    $charityButton: $element.find(selectors.charityButton),
  };

  const data = {
    settings,
    elements,
  };

  // for some reason, when trying to run select2 on a hidden element, it breaks every single
  // other instance of select2 on the page. this does mean that if the user does a drastic resize
  // of their window (e.g. from mobile to desktop), the charity selector won't be select2.
  // it'll just be a normal select. but i'm okay with this because that is such a tiny use case
  // and a regular select works just as fine and like who do they think they are doing resizes
  // like that, so rude
  if (data.elements.$charitySelect.is(':visible')) {
    data.elements.$charitySelect.select2();
  }

  data.elements.$charitySelect.on('change', () => updateCharityButton(data));

  updateCharityButton(data);

  $element.data(pluginName, data);
};

const plugin = function Plugin(options) {
  return this.each((index, element) => initialize(element, options));
};

plugin.defaults = defaults;

$(() => {
  if (plugin in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});
